var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.elementVisible)?_c('b-button',{staticClass:"local-lm-btn-row",attrs:{"icon-right":"history"},on:{"click":function($event){$event.preventDefault();return _vm.callActions(_vm.supplierOrderID, _vm.modalActions)}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66df50a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/miscellaneous/BtnRestoreOrder.vue
// module id = null
// module chunks = 